/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import React from 'react'

import { ActivityCard } from '@/components/quality-explorer/ActivityCard'
import { ActivityFilters } from '@/components/quality-explorer/ActivityFilters'
import { Activity, Kit } from '@/components/quality-explorer/types'
import { useActivitiesFilters } from '@/hooks/quality-explorer/useActivitiesFilters'

/** A description of the available properties for this component. */
type ActivitiesListWithFilterProps = {
  /** An array of the kits to filter by. */
  kits: Array<Kit>

  /** An array of the activities to display. */
  activities: Array<Activity>
}

/**
 * A list of activities with a filter to narrow down the list.
 */
const ActivitiesListWithFilter: React.FC<ActivitiesListWithFilterProps> = ({ activities, kits }) => {
  const { filters, setFilters, filteredActivities } = useActivitiesFilters(activities)

  return (
    <div className={'flex flex-col gap-y-6'}>
      <ActivityFilters kits={kits} filters={filters} onFilterChange={setFilters} />
      <div className={'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'}>
        {filteredActivities.map((activity) => (
          <ActivityCard key={activity.id} {...activity} />
        ))}
      </div>
    </div>
  )
}

export { ActivitiesListWithFilter }
